    /* BookingForm Validation
    ========================================================================= */
    var $bform = $('#booking-form'),
    url = $bform.attr('action');
    $bform.validate({
        submitHandler: function(form, e) {
            e.preventDefault();
            $('#submit-booking-form').attr('disabled', 'disabled');
            BookingApp.submitForm(form);
        },
        rules: {
            firstname: 'required',
            lastname: 'required',
            street: 'required',
            city: 'required',
            phone: 'required',
            email: {
                required: true,
                email: true
            },
        },
        messages: {
            firstname: 'Pflichtfeld',
            lastname: 'Pflichtfeld',
            street: 'Pflichtfeld',
            city: 'Pflichtfeld',
            phone: 'Pflichtfeld',
            email: 'Pflichtfeld',
        }
    })

    Vue.component('vue-datepicker', {
        template: '#vue-datepicker',
        props: ['start', 'end'],

        directives: {
            'datepicker': {  
                twoWay: true,   
                bind: function() {
                    var self = this
                    $(this.el).datepicker({
                        'minDate': 1,
                        onSelect: function(selectedDate) {
                            if (selectedDate) {
                                if ($(this).attr('id') === 'start') {
                                    $("#end").datepicker("option", "minDate", selectedDate);
                                }
                                self.vm.$dispatch('datepicker-changed', selectedDate)
                            }
                        }
                    })
                },
            }
        }
    })

/* AUTOCOMPLETE DIRECTIVE 
========================================================================= */
Vue.directive('autocomplete', {
    twoWay: true,

    bind: function() {
        var self = this

        this.el.addEventListener('keyup', function() {
            self.set(this.value)
        })

        var ac = new google.maps.places.Autocomplete(this.el);
        ac.addListener('place_changed', function() {
            self.set(self.el.value);
        })
    }
})

/* CURRENCY FILTER
========================================================================= */
Vue.filter('currencyDisplay', function(value) {
    return value.toFixed(2).replace(".", ",")
})

/* POSITIVE NUMBERS
========================================================================= */
Vue.filter('abs', {
    read: function(value) {
        return Math.abs(value) 
    },
    write: function(value) {
        return isNaN(value) ? 0 : Math.abs(value)
    }
})

/* APP
========================================================================= */
if( $('#BookingApp').length) {


Vue.http.options.emulateJSON = true;
var BookingApp = new Vue({
    el: '#BookingApp',

    ready: function() {
        for ( i = 0; i < dates.length; i++ ) {
            this.dates[i].value = dates[i]
        }
    },

    data: {
        dates: [
        { id: 'from', title: 'Departure', value: '' },
        { id: 'to', title: 'Return', value: '' }
        ],  

        pricing: {
            // lowSeason: 59,
            // highSeason: 69
            lowSeason: 69,
            highSeason: 79
        },

        extras: [
        { check: false, title: 'Roof rack', price: 20 },
        { check: false, title: 'Bicycle rack', price: 20 },
        { check: false, title: 'GPS', price: 20 },
        { check: false, title: '3G mobile WiFi', price: 20 },
        { check: false, title: 'Child\'s bed', price: 20 },
        { check: false, title: 'Sheets', price: 10 },
        ],

        sbplus: {
            title: 'SBplus (+ 5 EUR / Day)',
            check: false,
            price: 5
        },

        chairs: {
            title: 'Camping chairs (+ 10 EUR / Purchase)',
            check: false,
            number: 1,
            price: 10
        },

        schutzbrief: {
            title: 'Use of own roadside assistance (- 25 EUR)',
            check: false
        },

        delivery: {
            start: 'TripNuts Campervans, Saarbrücker Straße, Dortmund, Deutschland',
            // price: 39,
            price: 79,
            calculated: false,
            addresses: [
            { check: false, text: "Do you want us to drop off the camper?", value: '', distance: '', price: 0 },
            { check: false, text: "And / Or pickup?", value: '', distance: false, price: 0 }
            ]
        },

        cleaning: {
            title: 'Service fee',
            price: 39
        },

        customerDetails: {
            active: false,
            firstname: '',
            lastname: '',
            street: '',
            city: '',
            phone: '',
            email: '',
            numofpersons: '',
            text: ''
        }
    },

    computed: {
        days: function() {
            return this.calculateDays( this.dates[0].value, this.dates[1].value );
        },

        cleaningFee: function() {
            return ( this.days.total > 0 && this.days.total < 10 ) ? 39 : 0;
        },

        chairsTotal: function() {
            return this.chairs.check ? (this.chairs.number * this.chairs.price) : 0
        },

        priceCamper: function() {
            var lS = this.days.lowSeason * this.pricing.lowSeason,
            hS = this.days.highSeason * this.pricing.highSeason,
            total = lS + hS;

            return { lowSeason: lS, highSeason: hS, total: total }
        },

        priceTotal: function() {
            var extras = 0
            for ( var i = 0; i < this.extras.length; i++ ) {
                if ( this.extras[i].check == true ) {
                    extras += this.extras[i].price
                }
            }
            var sbplus = this.sbplus.check ? this.sbplus.price * this.days.total : 0
            
            var chairs = this.chairs.check ? this.chairsTotal : 0

            var delivery = this.delivery.addresses[0].check ? this.delivery.addresses[0].price : 0

            var pickup = this.delivery.addresses[1].check ? this.delivery.addresses[1].price : 0

            var cleaning = this.cleaningFee ? this.cleaning.price : 0

            if (this.schutzbrief.check && this.days.total > 0) {
                return ((this.priceCamper.total + extras + sbplus + chairs + delivery + pickup + cleaning) - 25)
            } else {
                return this.priceCamper.total + extras + sbplus + chairs + delivery + pickup + cleaning
            }
        }
    },

    methods: {
        checkout: function() {
            this.customerDetails.active = true;

            $('#checkout').show(200, function() {
                $('html, body').animate({
                    scrollTop: $('#checkout').offset().top + 'px'
                });
            });
        },

        alertMsg: function(e) {
            swal({
                title: "Upps..", 
                text: "Make sure the chosen rental period shows a minimum of 4 days.",
                confirmButtonColor: '#E84D22'
            });
        },

        parseDatepicker: function(datestring) {
            var newdate = datestring.split('/');
            var day = newdate[1];
            var month = newdate[0];
            var year = newdate[2];
            return new Date(year+'-'+month+'-'+day).valueOf();
        },

        calculateDays: function( start, end ) {
            var total = 0,
            lowSeason = 0,
            highSeason = 0;

            var from = this.parseDatepicker(start);

            var to = this.parseDatepicker(end);

            total = ( from <= to ) ? Math.round( ( to - from ) / ( 86400000 ) ) : 0

            if ( total > 0 ) {
                for ( var i = 0; i < total; i++ ) {
                    var month = new Date( from + ( i * 86400000 ) ).getMonth()
                    

                    if ( month < 5 || month > 7 ) {
                        lowSeason++
                    } else {
                        highSeason++
                    }
                }
            }

            return { total: total, lowSeason: lowSeason, highSeason: highSeason }
        },

        calculateDistance: function() {
            var self = this;
            var start = this.delivery.start;
            var destinations = [this.delivery.addresses[0].value, this.delivery.addresses[1].value];

            var dms = new google.maps.DistanceMatrixService();

            dms.getDistanceMatrix({
                origins: [start],
                destinations: destinations,
                travelMode: google.maps.TravelMode.DRIVING
            }, callback)

            function callback( response, status ) {
                if( status == google.maps.DistanceMatrixStatus.OK ) {
                    var results = response.rows[0].elements;
                    for ( var i = 0; i < results.length; i++ ) {
                        if ( results[i].status === "OK" ) {
                            self.delivery.addresses[i].distance = results[i].distance.text
                            self.delivery.addresses[i].price = ((Math.floor((results[i].distance.value / 1000) / 100) + 1) * self.delivery.price )
                        }
                    }
                }
            }
        },

        submitForm: function(form) {
            var bookingData = {
                dates: this.dates,
                extras: this.extras,
                sbplus: this.sbplus,
                delivery: this.delivery,
                days: this.days,
                cleaningFee: this.cleaningFee,
                chairs: this.chairs,
                schutzbrief: this.schutzbrief,
                chairsTotal: this.chairsTotal,
                priceCamper: this.priceCamper,
                priceTotal: this.priceTotal,
                customerDetails: this.customerDetails
            }
            this.$http({ url: $(form).attr('action'), method: 'POST', data: bookingData }).then(function (response) {
                if ( response.data === "success") {
                    swal({
                        title: 'Anfrage gesendet',
                        text: 'Vielen Dank!, Du bekommst eine Email sobald wir deine Anfrage bearbeitet haben.',
                        type: 'success',
                        confirmButtonColor: '#E84D22'
                    });
                    $('#submit-booking-form').removeAttr('disabled');
                    
                } else {
                    swal({
                        title: 'Upps..',
                        text: 'Deine Anfrage konnte nicht gesendet werden. Bitte schick uns eine Email an info@tripnuts.de',
                        type: 'warning',
                        confirmButtonColor: '#E84D22'
                    });
                    $('#submit-booking-form').removeAttr('disabled');
                }
            });
        }
    },

    events: {
        'datepicker-changed': function(selectedDate) {
            this.dates[0].value = document.getElementById('start').value
            this.dates[1].value = document.getElementById('end').value
        }   
    }
});


}
